import React, { useState, useEffect } from 'react';
import URL from 'url-parse';
import queryString from 'query-string';
import { useHistory, useLocation } from 'react-router';
import { FormattedMessage } from 'react-intl';
import Styled from 'styled';

import { keyEnterPressed } from 'lib/key-code/key-code';

import SearchInputWithButton from 'four-nets/ui-v2/search-input-with-button/search-input-with-button';
import Slider from 'four-nets/ui-v2/form/slider/slider';

import defaultStyles from './search-panel.scss';

interface Props {
    styles: typeof defaultStyles;

    query?: string;
    searchTitlesOnly?: boolean;
    target?: string;

    toggle?: boolean;
    submitOnToggle?: boolean;
}

const SearchPanel: React.FC<Props> = props => {
    const history = useHistory();
    const location = useLocation();

    const { toggle = true, styles, submitOnToggle } = props;

    const [focused, setFocused] = useState(false);
    const [query, setQuery] = useState(queryString.parse(location.search).query || '');
    const [searchTitlesOnly, setSearchTitlesOnly] = useState(Boolean(props.searchTitlesOnly));

    const handleSubmit = () => {
        const { target } = props;

        const url = new URL('/search/', {});

        url.set('query', {
            ...queryString.parse(location.search),
            query,
            page: 1,
            searchTitlesOnly: searchTitlesOnly.toString(),
        });

        if (target) {
            url.set('query', {
                ...url.query,
                target,
            });
        }

        history.push(url.href);
    };

    const onInputFocus = () => {
        setFocused(true);
    };

    const onInputBlur = () => {
        setFocused(false);
    };

    const onToggle = () => {
        setSearchTitlesOnly(value => !value);
        if (submitOnToggle) {
            handleSubmit();
        }
    };

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setQuery(event.target.value);
    };

    const onKeyUp = (e: React.KeyboardEvent) => {
        if (keyEnterPressed(event)) {
            handleSubmit();
        }
    };

    useEffect(() => {
        setQuery(queryString.parse(location.search).query || '');
        setSearchTitlesOnly(Boolean(props.searchTitlesOnly));
    }, [location, props.searchTitlesOnly]);

    return (
        <div className={styles.searchPanel} onKeyUp={onKeyUp}>
            <div className={styles.form}>
                <div className={styles.input}>
                    <FormattedMessage id='SEARCH_INPUT_PLACEHOLDER'>
                        {msg => (
                            <SearchInputWithButton
                                placeholder={msg as string}
                                value={query}
                                onChange={onChange}
                                submit={handleSubmit}
                                onBlur={onInputBlur}
                                onFocus={onInputFocus}
                            />
                        )}
                    </FormattedMessage>
                </div>
                {toggle ? (
                    <div className={styles.sliderDiv}>
                        <FormattedMessage id='SEARCH_ONLY_FORUM_TITLES'>
                            {msg => <Slider onChange={onToggle} label={msg} checked={searchTitlesOnly} />}
                        </FormattedMessage>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default Styled(defaultStyles)(SearchPanel);
